import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import { Edit2, Trash2 } from "react-feather";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const AllTask = ({ project_id, refreshKey }) => {
  const [subTasks, setSubTasks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editTask, setEditTask] = useState(null);

  useEffect(() => {
    fetchTasks(); // your API call to fetch tasks
  }, [project_id, refreshKey]);

  const fetchTasks = () => {
    axios
      .get(`${baseurl}getSubtasksByProjectId/${project_id}`)
      .then((res) => {
        if (res.data.subtasks) {
          setSubTasks(res.data.subtasks);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch subtasks", err);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this task?")) {
      axios
        .delete(`${baseurl}deleteSubtask/${id}`)
        .then(() => fetchTasks())
        .catch((err) => console.error("Delete failed", err));
    }
  };

  const handleUpdate = (task) => {
    setEditTask(task);
    setShowModal(true);
  };

  const handleUpdateSubmit = () => {
    console.log("Submitting updated task:", editTask); // 👈 Logs the data being sent
  
    axios
      .post(`${baseurl}updateSubtask`, editTask)
      .then(() => {
        setShowModal(false);
        setEditTask(null);
        fetchTasks();
  
        // Show success toast notification
        toast.success("Subtask updated successfully!");
      })
      .catch((err) => {
        console.error("Update failed", err);
  
        // Show error toast notification
        toast.error("Failed to update subtask. Please try again.");
      });
  };
  

  return (
    <div className=" ">
      <h2 className="chart-title text-start">All Tasks</h2>

      {subTasks.length > 0 ? (
        <div className="table-responsive">
          <table className="custom-table table table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>Task</th>
                <th>Status</th>
                {/* <th>Created At</th> */}
                <th>Assignees</th>
                <th>Note</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {subTasks.map((task, i) => (
                <tr key={task.id}>
                  <td>{i + 1}</td>
                  <td>{task.subtask}</td>
                  <td>{task.status || "No Status"}</td>
                  {/* <td>{new Date(task.created_at).toLocaleString()}</td> */}
                  <td>
                    {task.assignee_full_names?.length > 0 ? (
                      <div className="d-flex flex-wrap">
                        {task.assignee_full_names.map((name, index) => (
                          <div key={index} className="d-flex align-items-center mr-2 mb-1">
                            {task.assignee_profile_images[index] ? (

                                <div className="avatar-wrapper">
                              <img
                                src={`${imageUrl}assignee/${task.assignee_profile_images[index]}`}
                                alt={name}
                                style={{
                                  width: 25,
                                  height: 25,
                                  borderRadius: "50%",
                                  marginRight: "-12px", border: "2px solid #fff",
                                }} 
                              />
                              <div className="tooltip p-2">{name}</div>
                            </div>

                            ) : (
                              <div className="avatar-circle">{name?.charAt(0).toUpperCase() || "?"}</div>
                            )}
                            {/* <span className="assignee-name">{name}</span> */}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <span>No Assignees</span>
                    )}
                  </td>
                  <td>{task.note || "-"}</td>
                  <td>
                    <button className="btn-sm custom-btn blue me-1" onClick={() => handleUpdate(task)}>
                      <Edit2 size={15}/>
                    </button>
                    <button className="btn-sm custom-btn red" onClick={() => handleDelete(task.id)}>
                      <Trash2 size={15}/>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No tasks available for this project.</p>
      )}

      {/* Custom Modal */}
      {showModal && editTask && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h3>Update Task</h3>
              <span className="close-btn" onClick={() => setShowModal(false)}>
                &times;
              </span>
            </div>
            <div className="custom-modal-body text-start">


            <div className="mb-3">
            <label>Task</label>
              <input
                type="text" className="form-control"
                value={editTask.subtask}
                onChange={(e) => setEditTask({ ...editTask, subtask: e.target.value })}
              />
              </div>


              <div className="mb-3">
              <label>Status</label>
<select
  value={editTask.status} className="form-control"
  onChange={(e) => setEditTask({ ...editTask, status: e.target.value })}
>
  <option value="">-- Select Status --</option>
  <option value="Pending">Pending</option>
  <option value="In Progress">In Progress</option>
  <option value="Completed">Completed</option>
  <option value="On Hold">On Hold</option>
  <option value="Cancelled">Cancelled</option>
</select>
              </div>

              <div className="mb-3">
              <label>Note</label>
              <textarea
                rows={3} className="form-control" 
                value={editTask.note}
                onChange={(e) => setEditTask({ ...editTask, note: e.target.value })}
              />
           </div>
              




              
            </div>
            <div className="custom-modal-footer">
              <button className="custom-btn grey" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button className="custom-btn green" onClick={handleUpdateSubmit}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllTask;
